import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { NavMarker } from 'react-rhumb';

/* Inline replacement for the merch cards when their pricing query fails.
 * MERCH_CARD_ERROR is a Rhumb error marker on every public route, so the
 * failure is still recorded without taking down the rest of the page through
 * the error boundary. Shared by the hub pages and the HSOC v2 page. */
import { jsx as _jsx } from "react/jsx-runtime";
export function PublicMerchCardsError() {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MERCH_CARD_ERROR",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      type: "error",
      children: /*#__PURE__*/_jsx(Paragraph, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.merchCard.error.loadFailed"
        })
      })
    })
  });
}